import { createRoot } from "react-dom/client";
import App, { preloadRoute } from "./App.tsx";
import "./index.css";
import { startBrandColors } from "./lib/brandColors";
import { startCardLinks } from "./lib/cardLinks";
import { startWhatsAppMessages } from "./lib/whatsappMessage";
import { startNoOrphans } from "./lib/noOrphans";
import { startSliderSwipe } from "./lib/sliderSwipe";

// the open page's code first (pages load on demand, see lib/lazyPage), so the
// first render replaces the page's markup in the HTML with the same page;
// should it fail to load, the app renders anyway and loads it then. The text
// passes start after it, not on the markup about to be replaced.
preloadRoute(location.pathname)
  .catch(() => {})
  .then(() => {
    createRoot(document.getElementById("root")!).render(<App />);
    startBrandColors();
    startNoOrphans();
  });
startCardLinks();
startWhatsAppMessages();
startSliderSwipe();
